<template>
    <b-modal scrollable b-modal title="Parametri Vitali" ref="mdlParametriVitali" id="mdlParametriVitali" size="xl" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Parametro Vitale</label>
                    <span class="sa-data">{{ jsonData.descrizioneMisurazione }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaParametriVitaliValori" :fields="fields" :current-page="1" :per-page="500000" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(measurename)="item">
                            <span> {{ getLabelTraduora(item.item.measurename) }} </span>
                        </template>
                    </b-table>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note</label>
                        <span class="sa-data">{{ jsonData.note }}</span>
                    </b-col>
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    props: {},
    mixins: [UtilityMixin],
    components: {},
    data() {
        return {
            listKey: 0,
            pathResourceParamentriVitali: "/rsaconfigurazioneparametrivitali",
            pathResource: "/rsaparametrivitalitestate",
            id: null,
            parametriVitaaliOptions: [{ value: null, text: "-Seleziona Valore-" }],
            jsonData: { id: null, idAccettazione: "", descrizioneMisurazione: "", note: null, listaParametriVitaliValori: [] },
            filtro: {},
            fields: [
                { label: "Misura", key: "measurename" },
                { label: "Valore", key: "value", thStyle: "width: 20rem" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
    },
    watch: {},
    methods: {
        show(id) {
            let me = this;
            me.id = id;
            me.loadData();
            me.$refs.mdlParametriVitali.show();
        },
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            UtilityMixin.methods.restCallGet(link, null, me.resultResponse, me.resutlError);
        },
        resultResponse(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.listKey++;
        },
        resutlError(error) {
            console.log(error);
        },
        resutlErrorParametriVitaliDettagi(error) {
            console.log(error);
        },
        close() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlParametriVitali.hide();
        },
    },
};
</script>
